export const createInvoiceCreateState = (text = {}) => {
  const now = new Date();
  const dateValue = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}-${String(now.getDate()).padStart(2, '0')}`;
  const currentExercise = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}`;

  return {
    headerActions: [
      {
        key: 'back',
        label: text.create.headerActions.back,
        icon: 'fa-arrow-left',
        variant: 'secondary',
      },
    ],
    currency: 'MXN',
    issuer: {
      businessName: '',
      rfc: '',
      taxRegime: '',
      fiscalResidence: '',
    },
    customerOptions: [],
    selectedReceiver: null,
    taxRegimeOptions: [],
    cfdiUseOptions: [],
    serialOptions: [],
    paymentMethodOptions: [],
    paymentFormOptions: [],
    globalInvoicePeriodicityOptions: [],
    invoiceInfo: {
      date: dateValue,
      series: '',
      folio: '',
      serialId: '',
      paymentMethod: 'PPD',
      paymentForm: '99',
      isGlobal: 0,
      globalPeriodicity: '04',
      globalExercise: currentExercise,
    },
    concepts: [],
    comments: '',
    discountRate: 0,
    showConceptModal: false,
    conceptModalMode: 'create',
    editingConceptIndex: -1,
    submittingInvoice: false,
    receiverLocked: false,
    prefillPaymentId: 0,
    prefillPaymentCustomerId: 0,
  };
};
